export { EnviarCorreoModalEdit } from "./enviarcorreo";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/correo/index.tsx